import { get } from './P3Api';

class CategoryBrandApi {
  static async getCategoryBrands(categoryId) {
    return get(`categories/${categoryId}/brands`);
  }
}

export default CategoryBrandApi;
